/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { BusinessPartnerUser } from '@msdyn365-commerce/retail-proxy';

/**
 * Site Builder app configuration used to gate Cross Legal Entity inventory lookup.
 */
export interface ICrossEntityInventoryFeatureConfig {
    enableCrossLegalEntity?: boolean;
}

/**
 * Returns true when Cross-LE inventory lookup is enabled in Site Builder.
 * @param appConfig - The Site Builder app configuration.
 * @returns True when the feature is enabled.
 */
export const isCrossCompanyInventoryLookupEcommerceEnabled = (appConfig?: ICrossEntityInventoryFeatureConfig): boolean =>
    appConfig?.enableCrossLegalEntity === true;

/**
 * Returns true when the current user is a B2B (business partner) user.
 * Use this only for user-specific behavior. Site-level B2B eligibility should use isChannelTypeB2B.
 * @param businessPartnerUser - The current business partner user, if any.
 * @returns True when the user is a business partner user.
 */
export const isBusinessPartnerUser = (businessPartnerUser?: BusinessPartnerUser): boolean =>
    businessPartnerUser !== undefined && businessPartnerUser !== null;
